"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFileToAttachmentObject = void 0;
var file_extension_1 = __importDefault(require("file-extension"));
function formatFileToAttachmentObject(fileContents) {
    var _a = fileContents, id = _a.id, filename = _a.filename, createdAt = _a.createdAt, category = _a.category, contentType = _a.contentType, meta = _a.meta;
    var fileNameFallback = filename || '';
    var summary = (meta === null || meta === void 0 ? void 0 : meta.summary) || undefined;
    return {
        id: id,
        filename: fileNameFallback,
        fileExtension: (0, file_extension_1.default)(fileNameFallback),
        createdAt: new Date(createdAt).toISOString(),
        category: category,
        contentType: contentType,
        summary: summary,
    };
}
exports.formatFileToAttachmentObject = formatFileToAttachmentObject;
